import Fuse from "fuse.js";
import * as Yup from "yup";
import { Formik } from "formik"
import Select from "react-select";
import { toast } from "react-toastify";
import InputField from "../../atoms/InputField";
import TemplateForm from "../../atoms/TemplateForm";
import { REGISTER_MANTENIMIENTO } from "../../../api/apiMantenimiento";

const MantenimientoCreate = ({ refetch, onClose, options, optionsStaff }) => {
    const initialValues = {
        description: "",
        cost: "",
        date_service: "",
        status: "",
        propertieId: null,
        staffId: null
    };

    const optionsStatus = [
        { value: "Pendiente" , label:"Pendiente" },
        { value: "Realizado" , label:"Realizado" },
    ];

    const handleSubmit = async (values, { setSubmitting }) => {
        try {
            await REGISTER_MANTENIMIENTO(values);
            refetch();
            onClose();
            toast.success("Agregado exitosamente");
        } catch (error) {
            console.error(error);
            toast.error("Error al registrar gasto");
        } finally {
            setSubmitting(false);
        }
    };

    const validationSchema = Yup.object({
        description: Yup.string().required("La descripción es requerida"),
        cost: Yup.number().typeError("Monto debe ser un número").positive("Monto debe ser positivo").required("Monto es requerido"),
        date_service: Yup.string().required("La fecha es requerida"),
        propertieId: Yup.mixed().nullable().required("Selecciona un inmueble"),
    });

    return (
        <Formik initialValues={initialValues} onSubmit={handleSubmit} validationSchema={validationSchema}>
            {({ values, isSubmitting, setFieldValue }) => (
                <TemplateForm
                    fields={
                        <>
                            <div className="col-span-2">
                                <label htmlFor="propertieId" className="text-rs-azul font-bold"> Inmueble </label>
                                <Select
                                    name="propertieId"
                                    options={options}
                                    className="h-fit border border-blue-600 rounded-md"
                                    classNamePrefix="select"
                                    onChange={selected => {
                                        setFieldValue("propertieId", selected?.value || null);
                                    }}
                                    placeholder="Selecciona inmueble..."
                                    filterOption={createFuseFilter(options, ["label"])}
                                    isClearable
                                />
                            </div>
                            <div className="col-span-2">
                                <InputField name="description" label="Descripción del mantenimiento" placeholder="Ingrese la descripción"/>
                            </div>
                            <div className="col-span-2">
                                <label htmlFor="staffId" className="text-rs-azul font-bold"> Usuarios de mantenimiento </label>
                                <Select
                                    name="staffId"
                                    options={optionsStaff}
                                    className="h-fit border border-blue-600 rounded-md"
                                    classNamePrefix="select"
                                    onChange={selected => {
                                        setFieldValue("staffId", selected?.value || null);
                                    }}
                                    placeholder="Selecciona usuario..."
                                    filterOption={createFuseFilter(optionsStaff, ["label"])}
                                    isClearable
                                />
                            </div>
                            <InputField name="cost" label="Costo" placeholder="$ Costo" type="number"/>
                            <div>
                                <label htmlFor="status" className="text-rs-azul font-bold">Estatus del servicio </label>
                                <Select
                                    name="status"
                                    options={optionsStatus}
                                    className="h-fit border border-blue-600 rounded-md"
                                    classNamePrefix="select"
                                    onChange={selected => {
                                        setFieldValue("status", selected?.value || null);
                                    }}
                                    placeholder="Selecciona usuario..."
                                    isClearable
                                />
                            </div>
                            <InputField name="date_service" label="Fecha del servicio" type="date"/>
                        </>
                    }
                    isSubmitting={isSubmitting}
                    textButton="Aceptar"
                />
            )}
        </Formik>
    );
};

export default MantenimientoCreate;

const createFuseFilter = (optionsList, keys) => {
    const fuse = new Fuse(optionsList, {
        keys,
        threshold: 0.3,
        ignoreLocation: true,
        includeScore: false,
        useExtendedSearch: true,
    });

    return (candidate, input) => {
        if (!input) return true;
        const results = fuse.search(input);
        return results.some(res => res.item.value === candidate.value);
    };
};